'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify } from 'qs';
import classNames from 'classnames';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import HelpPopover from '@uw-it-sis/lib-react/lib/HelpPopover';

import GenEdUtils from '@uw-it-sis/lib-react-myplan/lib/GenEdUtils';

import CourseCatalog from './CourseCatalog';
import {CourseLearningFormats} from "../lib/Constants";
import Resources from "../common/Resources";

/**
 * Course Search start message.
 */
class CourseSearchStart extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.analyticsStore = appStore.getAnalyticsStore();
        this.addToAnalytics = this.addToAnalytics.bind(this);
        this.onShowBrowse =  this.onShowBrowse.bind(this);
    }

    addToAnalytics = (type, link) => {
        this.analyticsStore.addEvent(`Course-Browse-Link-To-${type}`, {}, {link: link})
    };

    onShowBrowse = () => {
        this.props.showBrowseHandler()
    };

    render() {
        let component = null;

        if (this.props.campus) {
            const GenEdReqs = GenEdUtils.getList();

            let GenEdLinks = GenEdReqs.map(function(genEd, index) {
                /*
                 * The 'Writing' Gen Ed can only apply to sections, so when search is catalog, hide the display of the
                 * 'W' gen ed for browse since results would be 0. 'hideCatalog' flag in GenEduUtils tells us if we need
                 * to hide from catalog search.
                 */
                if ( genEd.hideCatalog && ! this.props.isSectionSearch ) {
                    return null;
                } else {
                    let queryString = stringify({campus: this.props.campus, isSectionSearch: this.props.isSectionSearch, qs: genEd.code}, { addQueryPrefix: true });
                    return (
                        <li className="list-inline-item" key={index}>
                            <Link to={{pathname: "/courses", search: queryString}}
                                  onClick={() => this.addToAnalytics("Gen-Eds", genEd.title)}
                                  title={genEd.title}
                                  replace={true}>
                                {genEd.code}
                            </Link>
                        </li>
                    );
                }
            }.bind(this));

            const LearningFormats = Object.values(CourseLearningFormats);

            let LearningFormatLinks = LearningFormats.map((format, index) => {
                let queryString = stringify({campus: this.props.campus, isSectionSearch: this.props.isSectionSearch, qs: format.code}, { addQueryPrefix: true });
                return (
                    <li className="list-inline-item" key={index}>
                        <Link to={{pathname: "/courses", search: queryString}}
                              onClick={() => this.addToAnalytics("Learning-Formats", format.name)}
                              replace={true}>
                            {format.name}
                        </Link>
                    </li>
                );
            });

            component =
                <Row className="course-browse mt-3">
                    <Col xs={12} className={classNames("course-browse-show", {"d-flex justify-content-between d-sm-none": !this.props.showBrowse}, {"d-none": this.props.showBrowse})}>
                        <span>Not sure what to search?</span>
                        <Button variant="inline-link" onClick={this.onShowBrowse}>Browse courses</Button>
                    </Col>
                    <Col xs={12} md={4} className={classNames("course-browse-section", {"d-none d-sm-block": !this.props.showBrowse})}>
                        <div className="mb-3">
                            <h2>General Education</h2>
                        </div>
                        <ul className="list-inline list-inline-separator">
                            {GenEdLinks}
                        </ul>
                    </Col>
                    <Col xs={12} md={8} className={classNames("course-browse-section", {"d-none d-sm-block": !this.props.showBrowse})}>
                        <div className="mb-3">
                            <h2 className="d-inline align-middle me-2">Learning Format</h2>
                            {/*<HelpPopover title={Resources.HELP_CONTENT.learningFormat.title} placement="top">{Resources.HELP_CONTENT.learningFormat.contents}</HelpPopover>*/}
                        </div>
                        <ul className="list-inline list-inline-separator">
                            {LearningFormatLinks}
                        </ul>
                    </Col>
                    <Col xs={12} className={classNames("course-browse-section", {"d-none d-sm-block": !this.props.showBrowse})}>
                        <div className="mb-3">
                            <h2>{this.props.campus.toLowerCase() === 'seattle'.toLowerCase() ? 'Colleges, Schools and Programs':'Schools and Programs'}</h2>
                        </div>
                        <CourseCatalog campus={this.props.campus} isSectionSearch={this.props.isSectionSearch}/>
                    </Col>
                </Row>;
        }

        return (component);
    }
}

CourseSearchStart.propTypes = {
    campus: PropTypes.string,
    isSectionSearch: PropTypes.bool.isRequired,
    showBrowseHandler: PropTypes.func.isRequired
};

export default CourseSearchStart;